import i18n from "i18next";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/logo/logo.svg";
import logoLight from "../../assets/logo/logo_white.svg";
import { NAV_ROUTES } from "../../utils/routes";

const Logo = ({ isLightTheme }) => {
  const [language, setLanguage] = useState(0);

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  return (
    <Link
      to={`${NAV_ROUTES.get("HOME").PATHNAME}/${language}/`}
      className="no-underline"
    >
      <img
        alt="IP8Value Logo"
        src={isLightTheme ? logoLight : logo}
        className=" h-auto w-[108px]"
      />
    </Link>
  );
};

export default Logo;
